import jsPDF from "jspdf";

export default function useHtmlToPdfPrinter() {

  const print = ({
      domElement,
      documentName,
      orientation = 'portrait',
      format = 'letter',
      ...settings
  } : {
    domElement: HTMLElement
    documentName: string
    orientation?: 'landscape' | 'portrait'
    format?: string
    autoPaging?: boolean | 'slice' | 'text'
    margin?: number[]
    width?: number
    windowWidth?: number
  }) => {
    if (!domElement) throw new Error("Invalid Element");
    const doc = new jsPDF({orientation, format, unit: 'px'});
    doc.setFont('helvetica', 'normal');
    doc.html(domElement, {
      callback: () => doc.save(documentName),
      margin: [20, 20, 20, 20],
      autoPaging: 'text',
      width: 450,
      windowWidth: 675,
      ...settings
    });
  }

  return { print }
}
